import { mapGetters, mapActions } from 'vuex'

import MainButton from '@/components/MainButton/index'
import ResponseDialog from '@/components/ResponseDialog/index'
import Logo from '@/assets/the-long-ball-logo.svg'

export default {
  name: 'InviteUsers',
  components: {
    MainButton,
    ResponseDialog
  },
  props: {
    groupId: String
  },
  data: () => ({
    Logo,
    illustrationImage: require('@/assets/illustration.svg'),
    groupName: '',
    groupNameRules: [v => !!v || 'Group Name is required'],
    groupResponseDialog: false,
    dialogText: '',
    selectedUsers: [],
    users: [],
    selectedEmails: [],
    emailField: null,
    addUserResponseDialog: false,
    addUserResponseDialogText: '',
    isCreateGroup: true,
    groupDetails: {},
    notExistingEmail: null
  }),
  computed: {
    ...mapGetters('invite', [
      'CREATE_GROUP_RESPONSE',
      'USERS_LIST',
      'INVITE_FRIEND_RESPONSE',
      'GROUP_DETAILS'
    ]),
    ...mapGetters(['EMAIL_AVAILABILITY_RESPONSE'])
  },
  methods: {
    ...mapActions('invite', {
      fetchUsersAction: 'FETCH_USERS',
      fetchGroupDetailsAction: 'FETCH_GROUP_DETAILS'
    }),
    saveEmailFieldValue() {
      const email = this.$refs.emailField.$refs.input.value
      const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      if (valid) {
        this.$store.dispatch('CHECK_EMAIL_AVAILABILITY', { email }).then(() => {
          if (this.notExistingEmail) {
            if (this.selectedEmails.includes(email)) {
              this.addUserResponseDialogText = `Email '${email}' is already on your list`
              this.addUserResponseDialog = true
            } else {
              this.selectedEmails.push(email)
            }
            this.emailField = null
          }
        })
      } else {
        this.addUserResponseDialogText = 'Invalid email'
        this.addUserResponseDialog = true
      }

      return valid
    },
    selectUser(user) {
      if (user) {
        if (user.invited) {
          this.addUserResponseDialogText = `User '${user.username}' is already invited/included in this group`
          this.addUserResponseDialog = true
        } else {
          const userIndex = this.users.findIndex(x => x.id === user.id)
          this.users.splice(userIndex, 1)
          this.selectedUsers.push(user)
        }
      }
    },
    createGroup() {
      if (this.$refs.emailField.$refs.input.value) {
        const isEmailValid = this.saveEmailFieldValue()
        if (isEmailValid === false) {
          return
        }
      }

      if (this.$refs.groupForm.validate()) {
        const payload = {
          groupName: this.isCreateGroup ? this.groupName : null,
          groupDetails: !this.isCreateGroup ? this.groupDetails : null,
          selectedUsers: this.selectedUsers,
          selectedEmails: this.selectedEmails
        }
        const action = this.isCreateGroup ? 'CREATE_GROUP' : 'INVITE_FRIEND'
        if (
          !this.isCreateGroup &&
          this.selectedEmails.length === 0 &&
          this.selectedUsers.length === 0
        ) {
          this.dialogText = 'Please select a user to add to your group.'
          this.groupResponseDialog = true
          return
        }
        this.$store.dispatch(`invite/${action}`, payload)
      }
    },
    dialogButtonClick() {
      this.groupResponseDialog = false

      if (
        (this.CREATE_GROUP_RESPONSE && this.CREATE_GROUP_RESPONSE.success) ||
        (this.INVITE_FRIEND_RESPONSE && this.INVITE_FRIEND_RESPONSE.success)
      ) {
        this.$router.push({ path: '/profile' })
      }
    },
    addUserResponseDialogButtonClick() {
      this.addUserResponseDialog = false
    },
    unselectUser(user) {
      const index = this.selectedUsers.indexOf(user)
      this.selectedUsers.splice(index, 1)
      this.users.push(user)
    },
    unselectEmail(email) {
      const index = this.selectedEmails.indexOf(email)
      this.selectedEmails.splice(index, 1)
    },
    isInvited(userGroup) {
      return userGroup.groupId === parseInt(this.groupId)
    }
  },
  activated() {
    this.isCreateGroup = !this.groupId
    this.fetchUsersAction().then(() => {
      this.users = this.USERS_LIST.data.map(user => {
        return {
          id: user.id,
          username: user.username,
          invited: !this.isCreateGroup
            ? user.ftUserGroups.some(this.isInvited)
            : null
        }
      })
    })
    if (!this.isCreateGroup) {
      const payload = {
        groupId: this.groupId
      }
      this.fetchGroupDetailsAction(payload)
    }
  },
  watch: {
    CREATE_GROUP_RESPONSE(data) {
      if (data) {
        this.dialogText = data.message
        this.groupResponseDialog = true
      }
    },
    INVITE_FRIEND_RESPONSE(data) {
      if (data) {
        this.dialogText = data.message
        this.groupResponseDialog = true
      }
    },
    GROUP_DETAILS(groupDetails) {
      const { data } = groupDetails
      if (data) {
        this.groupDetails = data
      }
    },
    EMAIL_AVAILABILITY_RESPONSE(data) {
      if (!data.success) {
        this.dialogText = 'This email is already registered user'
        this.groupResponseDialog = true
        this.notExistingEmail = false
      } else {
        this.notExistingEmail = true
      }
    }
  },
  deactivated() {
    this.selectedUsers = []
    this.selectedEmails = []
    this.$refs.groupForm.reset()
  }
}
